// @flow

import { useFormikContext } from 'formik';
import React, { useContext } from 'react';

import { CLUSTER_DETAILS_CONFIG_MAP } from '../../../configuration/cluster-details';
import { CLUSTER_PROVIDER_BACKEND_NAME, CLUSTER_REGION_BACKEND_NAME } from '../../../constants';
import { SelectField } from '../../../formik-utils/FormFields';
import { ClusterContext } from '../../../contexts/ClusterContext';
import { useRegionOptionsWithGovCloudDisabledIfRequired } from '../../../custom-hooks/useRegionOptionsWithGovCloudDisabledIfRequired';

import { getRegionDropdownOptions } from './utils';

export const ClusterRegionsContainer = ({ disabled }) => {
  const { values } = useFormikContext();
  const clusterRegionsConfig = CLUSTER_DETAILS_CONFIG_MAP.get(CLUSTER_REGION_BACKEND_NAME);

  const cluster = useContext(ClusterContext);
  const dataUniverse = cluster?.cluster_configs?.region_details;

  const regionOptions = getRegionDropdownOptions(
    dataUniverse,
    values[CLUSTER_PROVIDER_BACKEND_NAME]
  );
  const filteredClusterRegions = useRegionOptionsWithGovCloudDisabledIfRequired(regionOptions);

  return (
    <SelectField
      disabled={disabled}
      fieldDisplayName={clusterRegionsConfig.displayName}
      fieldName={clusterRegionsConfig.backendFieldName}
      options={filteredClusterRegions}
      placeholder={null}
    />
  );
};
